import axios from "axios";

const appVersion = "v1";

const userAction = axios.create({
    baseURL: `https://quiz-api.roomeet.ir/api/${appVersion}`
})
const nodeApi = axios.create({
    baseURL: `https://node.roomeet.ir/api/${appVersion}`
})

/** توکن را در زمان هر درخواست از localStorage می‌خواند تا بعد از لاگین همیشه به‌روز باشد */
const getAuthConfig = () => {
    try {
        const LS_Token = JSON.parse(localStorage.getItem("userToken"));
        const token = LS_Token?.quizToken;
        return {
            headers: {
                ...(token && { 'Authorization': "Bearer " + token }),
                'Accept': '*/*',
            }
        };
    } catch {
        return { headers: { 'Accept': '*/*' } };
    }
};

const getNoCacheQuery = () => ({ _ts: Date.now() });

const getUploadAuthConfig = () => {
    try {
        const LS_Token = JSON.parse(localStorage.getItem("userToken"));
        const token = LS_Token?.quizToken;
        return {
            headers: {
                ...(token && { 'Authorization': "Bearer " + token }),
                'Contetnt-Type': "multipart/form-data",
                'Accept': 'application/json',
                'type': "formData",
            }
        };
    } catch {
        return {
            headers: {
                'Contetnt-Type': "multipart/form-data",
                'Accept': 'application/json',
                'type': "formData",
            }
        };
    }
};

var previewConfig = (tkn) => {
    return {
        headers: {
            'Authorization': "Bearer " + tkn,
            'Contetnt-Type': "multipart/form-data",
            'Accept': 'application/json',
            'type': "formData",
            "Access-Control-Allow-Origin": "*"
            //     'Access-Control-Allow-Credentials': 'true',
            //     'mode': 'cors',
        }
    }
}


const userLogin = async (data) => {
    try {
        let response = await nodeApi.post(`/auth/login`, data)
        return (response.data)
    } catch (error) {
        return error.response?.data || { customCode: true, error: 'اتصال به سرور برقرار نشد. لطفاً پس از چند لحظه دوباره تلاش کنید.' };
    }
}

/**
 * تبادل توکن Node با توکن Sanctum برای استفاده در APIهای آزمون Laravel
 */
const exchangeNodeToken = async (nodeToken) => {
    try {
        let response = await userAction.post(`/auth/exchange-node-token`, { node_token: nodeToken })
        return (response.data)
    } catch (error) {
        return error.response?.data || { message: 'خطا در دریافت توکن آزمون', status: 'failed' };
    }
}

const logoutUser = async () => {
    try {
        let response = await userAction.post(`/logout`, {}, getAuthConfig())
        return (response.data)
    } catch (error) {
        return error.response?.data || { status: 'failed' };
    }
}

const guestVerification = async(quizCode) => {
    try {
        let response =  await nodeApi.get(`/quiz-on-join?code=${quizCode}`)
        return(response.data)
    } catch (error) {
        return(error.response);
    }
}
const getSchoolName = async(quizCode) => {
    // console.log(nodeApi);
    // console.log( typeof process.env.REACT_APP_API_URL + process.env.REACT_APP_VERSION);
    try {
        let response =  await nodeApi.get(`/school-info?code=${quizCode}`, {
            params: getNoCacheQuery(),
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
            }
        })
        return(response.data)
    } catch (error) {
        return(error.response);
    }
}

const confirmMessageRequest = async (name ,phone_num,quizID) => {
    // console.log(name,phone_num,quizID);
    try {
        let response = await nodeApi.post(`/detection-submit-number`, { name : name ,phone: phone_num,quizCode :quizID })
        return (response.data)
    } catch (error) {
        return(error.response.data);
    }
}
const confirmGuestLoginRequest = async (loginData) => {
    try {
        let response = await nodeApi.post(`/detection-submit-code`, loginData)
        return (response.data)
    } catch (error) {
        console.log(error.message);
    }
}
const guestLoginPhone = async (loginData) => {
    // console.log(loginData);
    try {
        let response = await userAction.post(`/guest/join/quiz`, loginData)
        return (response.data)
    } catch (error) {
        return(error.response.data);
    }
}

const examDatails = async (examID) => {
    try {
        let response = await userAction.get(`/site/quiz/join/${examID}`, {
            params: getNoCacheQuery(),
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
            }
        })
        return (response.data)
    } catch (error) {
        console.log(error.message);
    }
}

const attemptToJoinExam = async (examID,token) => {
    try {
        const baseConfig = token ? previewConfig(token) : getAuthConfig();
        let response = await userAction.get(`/site/quiz/attempt/join/${examID}`, {
            ...baseConfig,
            params: getNoCacheQuery(),
            headers: {
                ...(baseConfig?.headers || {}),
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
            },
        })
        return (response.data)
    } catch (error) {
        return error.response?.data || { status: 'error', message: 'خطا در اتصال به سرور' };
    }
}

const getCurrentAttempt = async (quizCode) => {
    try {
        const baseConfig = getAuthConfig();
        let response = await userAction.get(`/site/quiz/attempt/current/${quizCode}`, {
            ...baseConfig,
            params: getNoCacheQuery(),
            headers: {
                ...(baseConfig?.headers || {}),
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
            },
        })
        return (response.data)
    } catch (error) {
        return error.response?.data || { attempt: null, status: 'error' };
    }
}

/** ذخیره ایندکس سوال جاری (نمایش تکی) برای ادامه پس از خروج و ورود مجدد */
const saveAttemptCurrentQuestionIndex = async (attemptId, currentQuestionIndex) => {
    try {
        await userAction.post(
            `/site/quiz/attempt/current-question-index`,
            { attempt_id: attemptId, current_question_index: currentQuestionIndex },
            getAuthConfig()
        );
    } catch (error) {
        console.log(error?.message || error);
    }
};
const finishExam = async (attemptID) => {
    if (attemptID == null || attemptID === "" || attemptID === "undefined") {
        return { status: "not-found", message: "شناسه تلاش آزمون نامعتبر است." };
    }
    try {
        let response = await userAction.get(`/site/quiz/finish/${attemptID}`, getUploadAuthConfig())
        return (response.data)
    } catch (error) {
        return error.response?.data || { status: 'error', message: error.message || 'خطا در اتمام آزمون' };
    }
}
const leaveExam = async (attemptID) => {
    try {
        let response = await userAction.get(`/site/quiz/leave/${attemptID}`, getUploadAuthConfig())
        return (response.data)
    } catch (error) {
        console.log(error.message);
    }
}

/**
 * فراخوانی اتمام آزمون هنگام بستن تب - از fetch با keepalive استفاده می‌کند
 * تا درخواست حتی پس از بسته شدن صفحه هم ارسال شود
 */
const finishExamOnUnload = (attemptID) => {
    try {
        const LS_Token = JSON.parse(localStorage.getItem("userToken"));
        const token = LS_Token?.quizToken;
        const url = `${userAction.defaults.baseURL}/site/quiz/finish/${attemptID}`;
        fetch(url, {
            method: 'GET',
            keepalive: true,
            headers: {
                ...(token && { 'Authorization': "Bearer " + token }),
                'Accept': 'application/json',
            },
        });
    } catch (e) {
        // ignore - page is unloading
    }
}

/**
 * فراخوانی ترک آزمون هنگام بستن تب - از fetch با keepalive استفاده می‌کند
 * تا درخواست حتی پس از بسته شدن صفحه هم ارسال شود
 */
const leaveExamOnUnload = (attemptID) => {
    try {
        const LS_Token = JSON.parse(localStorage.getItem("userToken"));
        const token = LS_Token?.quizToken;
        const url = `${userAction.defaults.baseURL}/site/quiz/leave/${attemptID}`;
        fetch(url, {
            method: 'GET',
            keepalive: true,
            headers: {
                ...(token && { 'Authorization': "Bearer " + token }),
                'Accept': 'application/json',
            },
        });
    } catch (e) {
        // ignore - page is unloading
    }
}

const postFormData = async (formData) => {
    try {
        let response = await userAction.post(`/site/quiz/file/upload`, formData, getUploadAuthConfig())
        return (response.data)
    } catch (error) {
        console.log(error.message);
    }
}

/**
 * آپلود فایل با پشتیبانی از نوار پیشرفت
 * @param {FormData} formData
 * @param {function(number): void} onProgress - callback با درصد (0-100)
 */
const postFormDataWithProgress = async (formData, onProgress) => {
    try {
        const config = {
            ...getUploadAuthConfig(),
            onUploadProgress: (progressEvent) => {
                if (progressEvent.total && onProgress) {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    onProgress(percent);
                }
            },
        };
        let response = await userAction.post(`/site/quiz/file/upload`, formData, config);
        return (response.data);
    } catch (error) {
        console.log(error.message);
    }
}

const storeFileURL = async (fileData) => {
    try {
        let response = await userAction.post(`/site/quiz/file/store`, fileData, getUploadAuthConfig())
        return (response.data)
    } catch (error) {
        console.log(error.message);
    }
}

const deleteFile = async (fileId) => {
    try {
        let response = await userAction.delete(`/site/quiz/file/delete/${fileId}`, getAuthConfig())
        return (response.data)
    } catch (error) {
        console.log(error.message);
    }
}

const postUserDescriptionAnswer = async (id, attemptID, userAnswer) => {

    let questionAnswerData = {
        question_id: id,//id
        attempt_id: attemptID,
        answer: userAnswer ? userAnswer : null
    };

    try {
        let response = await userAction.post(`/site/quiz/answer`, questionAnswerData, getUploadAuthConfig())
        return (response.data)
    } catch (error) {
        console.log(error.message);
    }
}
const postUserTestAnswer = async (id, attemptID, userAnswer) => {

    let questionAnswerData = {
        question_id: id,//id
        attempt_id: attemptID,
        option_id: userAnswer
    };
    try {
        let response = await userAction.post(`/site/quiz/answer`, questionAnswerData, getUploadAuthConfig())
        return (response)
    } catch (error) {
        console.log(error.message);
    }
}

const testAnswerCancel = async (optionID) => {
    try {
        let response = await userAction.delete(`/site/quiz/delete/answer/${optionID}`, getAuthConfig())
        return (response)
    } catch (error) {
        console.log(error.message);
    }
}

const previewExam = async (quiz_code,token) => {
    try {
        let response = await userAction.get(`/panel/super-admin/preview/quiz/${quiz_code}`, previewConfig(token))
        return (response.data)
    } catch (error) {
        console.log(error.message);
    }
}



export {
    userLogin, exchangeNodeToken, logoutUser, examDatails, confirmMessageRequest, confirmGuestLoginRequest, attemptToJoinExam, getCurrentAttempt, saveAttemptCurrentQuestionIndex, finishExam, finishExamOnUnload, leaveExam, leaveExamOnUnload, postFormData,
    postFormDataWithProgress, postUserDescriptionAnswer, storeFileURL, deleteFile, postUserTestAnswer, testAnswerCancel, previewExam ,getSchoolName ,guestVerification,
    guestLoginPhone
};